module.exports = __webpack_public_path__ + "static/img/all-bg.12716b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cash-tree/all-bg.png
// module id = /LpG
// module chunks = 213